import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=1f064f96"
import script from "./Nps.vue?vue&type=script&setup=true&lang=js"
export * from "./Nps.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports